/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Reopen_DescInputs */

const vi_einvoice_reopen_desc = /** @type {(inputs: Einvoice_Reopen_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn sẽ quay lại danh sách chờ xuất hóa đơn.`)
};

/**

* @param {Einvoice_Reopen_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_reopen_desc = /** @type {((inputs?: Einvoice_Reopen_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Reopen_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_reopen_desc(inputs)
});